/** Типы записей в календаре */
export const CALENDAR_ENTRY_KINDS = [
  {
    id: "training",
    label: "Групповая тренировка",
    hint: "Занятие группы по расписанию или разово",
    icon: "👥",
  },
  {
    id: "individual",
    label: "Индивидуальная",
    hint: "Персональная тренировка с одним клиентом",
    icon: "🎯",
  },
  {
    id: "event",
    label: "Соревнование",
    hint: "Соревнование или турнир для участников клуба",
    icon: "🏆",
  },
];

export function calendarEntryKindMeta(id) {
  return CALENDAR_ENTRY_KINDS.find((k) => k.id === id) || CALENDAR_ENTRY_KINDS[0];
}

export function calendarEntryTitle(kind) {
  if (kind === "event") return "Новое соревнование";
  if (kind === "individual") return "Индивидуальная тренировка";
  return "Групповая тренировка";
}

export const INDIVIDUAL_SESSION_COLOR = "#0d9488";

export function eventKindLabel(eventKind) {
  if (eventKind === "competition") return "Соревнование";
  if (eventKind === "meeting") return "Собрание";
  return "Событие";
}
